module.exports = __webpack_public_path__ + "img/Asset 14@150x.d5c14295.png";